import React from "react"
import styled from "styled-components"
import media from "styles/media"
import colors from "styles/colors"
import text from "styles/text"

const QaComponent = ({ content }) => {
  const QaData = content?.content?.map((item, index) => {
    return (
      <Item>
        <Question>{item?.question}</Question>
        <Answer dangerouslySetInnerHTML={{ __html: item?.answer }} />
      </Item>
    )
  })

  return (
    <Wrapper>
      <HeaderDiv>
        {content?.header && <Header>{content?.header}</Header>}
      </HeaderDiv>
      <ContentWrapper>{QaData}</ContentWrapper>
    </Wrapper>
  )
}

export default QaComponent

const Answer = styled.p`
  ${text.bodySm}
`

const Question = styled.h5`
  ${text.h5}

  ${media.mobile} {
    ${text.h4};
  }
`

const Item = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.389vw;
  ${media.fullWidth} {
    gap: 20px;
  }

  ${media.tablet} {
    gap: 1.953vw;
  }

  ${media.mobile} {
    gap: 4.673vw;
  }
`

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${colors.lightPurpleGrey};
  color: ${colors.black};
  gap: 2.778vw;
  padding: 2.778vw;
  margin: 1.389vw 0vw;
  border-radius: 1.111vw;

  ${media.fullWidth} {
    padding: 40px;
    margin: 20px 0px;
    gap: 40px;
    border-radius: 16px;
  }

  ${media.tablet} {
    padding: 3.906vw;
    margin: 1.953vw 0vw;
    gap: 3.906vw;
    border-radius: 1.563vw;
  }

  ${media.mobile} {
    padding: 9.346vw;
    margin: 4.673vw 0vw;
    gap: 9.346vw;
    border-radius: 3.738vw;
  }
`

const Header = styled.h5`
  ${text.h5}

  ${media.mobile} {
    ${text.h4};
  }
`

const HeaderDiv = styled.div`
  background-color: ${colors.mediumPurple};
  color: ${colors.white};
  margin: 1.389vw 0vw;
  padding: 1.111vw;
  border-radius: 0.278vw;

  ${media.fullWidth} {
    margin: 20px 0px;
    padding: 16px;
    border-radius: 4px;
  }

  ${media.tablet} {
    margin: 1.953vw 0vw;
    padding: 1.563vw;
    border-radius: 0.391vw;
  }

  ${media.mobile} {
    margin: 4.673vw 0vw;
    padding: 3.738vw;
    border-radius: 0.935vw;
  }
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 79.444vw;

  ${media.fullWidth} {
    width: 1144px;
  }

  ${media.tablet} {
    width: 92.09vw;
  }

  ${media.mobile} {
    width: 88.551vw;
  }
`
